import { PILLOW_TALK_SUPPORT_LOCALES } from 'providers/messaging/constants';
import { SupportedLanguageCode } from 'providers/messaging/types';
import { Vertical } from 'utils/vertical/vertical';

export const isString = (value: unknown): value is string => value !== null && typeof value === 'string';

export const assertIsString = (value: unknown): string => {
  if (isString(value)) {
    return value;
  }

  throw new TypeError('Value is not string');
};

export const isNumber = (value: unknown): value is number =>
  value !== null && typeof value !== undefined && !isNaN(Number(value));

export const assertIsNumber = (value: unknown): number => {
  if (isNumber(value)) {
    return Number(value);
  }

  throw new TypeError('Value is not number');
};

export const isVertical = (value: unknown): value is Vertical =>
  typeof value === 'string' && Object.values(Vertical).includes(value as Vertical);

export const assertIsVertical = (value: unknown): Vertical => {
  if (isVertical(value)) {
    return value;
  }
  throw new TypeError(`Input "${value}" is not a valid vertical`);
};

export const isPillowTalkSupportedLanguageCode = (value: unknown): value is SupportedLanguageCode =>
  PILLOW_TALK_SUPPORT_LOCALES.includes(value as SupportedLanguageCode);
